
<div class="flex flex-row items-center justify-center">
  <a
    href="https://forms.office.com/e/c0KmUYNMQf"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="assets/images/feedback.jpg"
      alt="Feedback-Formular öffnen"
      class="w-full max-w-64 rounded-lg shadow-lg hover:opacity-90 hover:scale-105 transition"
    />
  </a>
</div>
